import { render, staticRenderFns } from "./administrationAgentInfoDetails.vue?vue&type=template&id=21bccd66&"
import script from "./administrationAgentInfoDetails.vue?vue&type=script&lang=js&"
export * from "./administrationAgentInfoDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports